<template>
  <div class="custom-card flex flex-col gap-4">
    <accordion>
      <accordion-item title="User Information">
        <div>
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-4 col-lg-4 col-12">
                <div class="picture-upload-form text-center">
                  <div class="my-3">
                    <image-uploader
                      :imageUrl="user.imageurl"
                      @input="uploadImage($event)"
                      @remove-image="removeImage"
                      :isUploadingImage="isUploadingImage"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-12 col-12">
                <div class="input-row">
                  <div class="new-user-form__single-input-wrapper">
                    <label for="fname" class="label">First Name</label>
                    <input
                      type="text"
                      class="input"
                      v-model="user.firstname"
                      placeholder="-- Enter First Name --"
                    />
                  </div>
                  <div class="new-user-form__single-input-wrapper">
                    <label for="mname" class="label">Middle Name</label>
                    <input
                      type="text"
                      class="input"
                      v-model="user.middlename"
                      placeholder="-- Enter Middle Name --"
                    />
                  </div>
                  <div class="new-user-form__single-input-wrapper">
                    <label for="lname" class="label">Last Name</label>
                    <input
                      type="text"
                      class="input"
                      v-model="user.lastname"
                      placeholder="-- Enter Last Name --"
                    />
                  </div>
                </div>
                <div class="input-row my-4">
                  <div class="new-user-form__single-input-wrapper">
                    <label for="gender" class="label">Gender</label>
                    <el-select v-model="user.gender" placeholder="-- Select --">
                      <el-option
                        v-for="gender in genders"
                        :key="gender"
                        :label="gender"
                        :value="gender"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div class="new-user-form__single-input-wrapper">
                    <label for="email" class="label">Work Email</label>
                    <input type="email" class="input" v-model="user.email" />
                  </div>
                  <div class="new-user-form__single-input-wrapper">
                    <label for="number" class="label">Phone Number</label>
                    <vue-tel-input v-model="user.mobile_no"></vue-tel-input>
                    <div v-if="isValidPhone">
                      <p class="text-red-600">Phone number must be numeric values only</p>
                    </div>
                    <div v-if="isValidPhoneLength">
                      <p class="text-red-600">Phone number must be 11 characters long</p>
                    </div>
                  </div>
                </div>
                <div class="input-row">
                  <div class="new-user-form__single-input-wrapper">
                    <label for="gender" class="label">Address</label>
                    <vue-google-autocomplete
                      id="map2"
                      ref="shipperAddress"
                      :value="user.locale.address"
                      classname="input"
                      placeholder="Enter address"
                      v-on:placechanged="getAddress"
                    >
                    </vue-google-autocomplete>
                  </div>
                  <div class="new-user-form__single-input-wrapper">
                    <label for="gender" class="label">State</label>
                    <input type="text" class="input" v-model="user.locale.state" />
                  </div>
                  <div class="new-user-form__single-input-wrapper">
                    <label for="gender" class="label">Country</label>
                    <input type="text" class="input" v-model="user.locale.country" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </accordion-item>
      <accordion-item title="Role & Privileges">
        <div>
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-6 col-lg-4 col-12">
                <div class="my-3">
                  <p>Roles that you have been assigned</p>
                </div>
              </div>
              <div class="col-md-12 col-lg-12 col-12">
                <div class="input-row">
                  <div class="new-user-form__single-input-wrapper">
                    <label for="fname" class="label">Role</label>
                    <input
                      type="text"
                      disabled
                      class="input"
                      style="width: 302px"
                      v-model="parseRole.roleName"
                    />
                  </div>

                  <!-- <base-button
                    text="View Privilege"
                    background="white"
                    color="text-primary-yellow"
                    style="white-space: nowrap"
                  ></base-button> -->
                </div>
              </div>
            </div>
          </div>
          <hr />
        </div>
      </accordion-item>
      <accordion-item title="Locations">
        <div>
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-6 col-lg-4 col-12">
                <div class="my-3">
                  <p>Locations where you've been assigned</p>
                </div>
              </div>
              <div
                class="col-md-12 col-lg-12 col-12"
                v-for="(location, i) in locations"
                :key="i"
              >
                <div class="input-row">
                  <div class="new-user-form__single-input-wrapper">
                    <label for="fname" class="label">Location</label>
                    <input
                      type="text"
                      disabled
                      class="input"
                      style="width: 302px"
                      v-model="location.location.locationName"
                      placeholder="-- Enter First Name --"
                    />
                  </div>
                  <!-- <div class="new-user-form__single-input-wrapper">
                    <label for="lname" class="label">Role</label>
                    <input
                      type="text"
                      class="input"
                      style="width: 302px"
                      v-model=""
                      placeholder="-- Enter Last Name --"
                    />
                  </div> -->
                  <!-- <base-button
                    text="View Privilege"
                    background="white"
                    color="text-primary-yellow"
                    style="white-space: nowrap"
                  ></base-button> -->
                </div>
              </div>
            </div>
          </div>
          <hr />
        </div>
      </accordion-item>
      <div class="flex items-center my-4 justify-between">
        <div class="cursor-pointer" @click="$router.go(-1)">
          <p>Cancel</p>
        </div>
        <primary-button buttonText="Save" @click="updateUser" :loading="updatingUser" />
      </div>
    </accordion>
  </div>
</template>

<script>
import ImageUploader from "@/components/3pl/Users/ImageUploader";
import timezones from "@/utilities/timezones";
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
  name: "ProfileInfo",
  components: {
    ImageUploader,
    VueGoogleAutocomplete,
  },
  data() {
    return {
      showSecurityQuestionModal: false,
      showPasswordModal: false,
      showTwoFactorModal: false,
      timezones: timezones,
      locations: [],
      user: {},
      checkMe: "",
      genders: ["Male", "Female"],
      languages: ["English"],
      employmentTypes: [
        "Full-time",
        "Part-time",
        "Intern",
        "Company-paid Temporary",
        "Independent Contractor",
        "Agency-paid Temporary",
        "Vendor Employee",
        "Volunteer",
      ],
      address: {
        state: "",
        country: "",
      },
      creatingUser: false,
      roles: [],
      geoData: [],
      states: [],
      cities: [],
      countries: ["Nigeria"],
      selectedRoleId: "",
      isUploadingImage: false,
      updatingUser: false,
    };
  },
  watch: {
    address: {
      deep: true,
      immediate: true,
      handler(val) {
        console.log(JSON.stringify(val, null, 2));
        this.user.country = val.country;
        this.user.state = val.state;
      },
    },
    user: {
      deep: true,
      immediate: true,
      handler(val) {
        console.log(val);
        this.geoCoderPayload.lat = val.lat;
        this.geoCoderPayload.long = val.long;
        if (this.geoCoderPayload.lat && this.geoCoderPayload.long) {
          this.getGeoCoder();
        }
      },
    },
    "user.state"(val) {
      this.user.state = val;
    },
    "user.country"(val) {
      this.user.country = val;
    },
  },
  computed: {
    isValidPhone() {
      let phone = this.user.mobile_no;
      var patt = /[a-z]+/i;

      return patt.test(phone);
    },
    isValidPhoneLength() {
      return this.user.mobile_no ? this.user.mobile_no.replace(/\s+/g, "").length != 11 ? true : false : false;
    },
    disableButton() {
      return this.shouldDisableButton(this.newUser);
    },
    geoCoderPayload() {
      return {
        lat: null,
        long: null,
      };
    },
    parseRole() {
      let role = "";
      if (this.user.role) {
        role = JSON.parse(this.user?.role);
      }
      return role;
    },
  },
  async mounted() {
    this.user = JSON.parse(localStorage.getItem("loggedInUser"));
    await this.getUserLocation();
    if (!this.user.lat) {
      this.user.lat = "";
    }
    if (!this.user?.long) {
      this.user.long = "";
    }

    if(!this.user?.locale){
      this.user.locale = {
          address: "",
          country: "",
          state: "",
          city : "",
          lat : "",
          long: ""
        }
    }
    if (!this.user?.locale?.country) {
      this.user.locale.country = "";
    } else {
      this.address.country = this.user.country;
    }
    if (!this.user?.locale?.state) {
      this.user.locale.state = "";
    } else {
      this.address.state = this.user.state;
    }
    console.log(this.user);
    if (!this.user) {
      this.$router.push("/login");
    }
  },
  methods: {
    async getGeoCoder() {
      try {
        const response = await this.$_getStateNameWithDim(this.geoCoderPayload);
        // console.log(JSON.stringify(response.data, null, 2));
        this.geoData = response.data;
        this.assignCountryAndState(response.data);
      } catch (error) {
        this.handleError();
      }
    },
    async assignCountryAndState(data) {
      this.address.state = data.state;
      this.address.country = data.address.country;
    },
    async updateUser() {
      this.updatingUser = true;

      let payload = {
        user: {
          firstname: this.user.firstname,
          middlename: this.user.middlename,
          lastname: this.user.lastname,
          gender: this.user.gender,
          email: this.user.email,
          mobile_no: this.user.mobile_no,
          locale: {
            address: this.user?.locale?.address,
            country: this.user?.locale?.country,
            state: this.user?.locale?.state,
            city : this.user?.locale?.city,
            lat : this.user?.locale?.lat,
            long: this.user?.locale?.long
          },
          imageurl: this.user.imageurl,
        },
      };

      try {
        let response = await this.$_saveAccountOwnerInformation(payload);

        this.$store.dispatch("saveUserDetails", response.data.data.user);
        this.generateToast("Your information has been updated!", "success");
        this.updatingUser = false;
        this.$router.push({ name: "AccountSettings" });
      } catch (error) {
        this.handleError(error);
        this.updatingUser = false;
      }
    },
    async uploadImage(image) {
      this.isUploadingImage = true;
      const formData = new FormData();
      formData.append("file", image);
      formData.append("upload_preset", "zunt8yrw");

      try {
        let response = await this.$_uploadImage(formData);

        this.user.imageurl = response.data.fileUrl;
        this.generateToast("Image uploaded", "success");
        this.isUploadingImage = false;
      } catch (error) {
        this.handleError(error);
        this.isUploadingImage = false;
      }
    },
    removeImage() {
      this.user.imageurl = null;
    },
    async getAllStates() {
      try {
        let response = await this.$_getAllStates();
        console.log(response);
        this.states = response.data.findState;
      } catch (error) {
        this.handleError(error);
      }
    },
    async getUserLocation() {
      try {
        let response = await this.$_getUserLocation(this.user.id);
        console.log(JSON.stringify(response.data.data, null, 2));
        this.locations = response.data.data;
      } catch (error) {
        this.handleError;
      }
    },
    getAddress(addressData) {
      console.log(addressData, "gogole soem");
      this.user.locale.address = addressData.route;
      this.user.locale.country = addressData.country;
      this.user.locale.city = addressData.locality;
      this.user.locale.state = addressData.administrative_area_level_1;
      this.user.locale.lat = addressData.latitude;
      this.user.locale.long = addressData.longitude;
    },
  },
};
</script>

<style lang="scss" scoped>
.picture-upload-form {
  /* border: 1px solid #edf2ef; */
  border-radius: 10px;
  padding: 1.55rem 1rem;
}

.picture-upload-form__img-wrapper {
  position: relative;
}

.user-img {
  width: 10rem;
  margin: 1.5rem auto;
}

.upload-img-icon {
  position: absolute;
  right: 3.5rem;
  bottom: 1rem;
}

.picture-upload-form__meta {
  padding-top: 1rem;
}

.label {
  font-size: 0.9rem;
}

.input {
  margin-bottom: 0.5rem;
}

.new-user-form__col-three {
  padding-top: 1.25rem;
}

hr {
  margin: 2rem 0;
}

.input-row {
  width: 100%;
  display: flex;
}

.input-row > div {
  width: 100%;
  padding-right: 1rem;
}

.modal-input {
  background: #fafafd;
  border: 0.5px solid #c5d1e6;
  height: 2.75rem;
  border-radius: 4px;
  display: flex;

  input {
    border: none;
    background: transparent;
  }

  span {
    align-self: center;
    padding-right: 0.5rem;
    color: #747474;
    cursor: pointer;
  }
}

@media screen and (max-width: 768px) {
  .input-row {
    flex-direction: column;
  }

  .input-row div {
    width: 100%;
  }
}
</style>
